import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import { ClientDto } from '../../services/api/sharedTypes/Client'
import { getEmptyNotificationObject } from '../../utils/notification-utils'
import { NotificationDto } from '../../services/api/sharedTypes/Notification'
import Notification from './Notification'
import SmallPlusButton from '../common/SmallPlusButton'

interface NotificationsListProps {
    client: ClientDto
    onChange: (client: ClientDto) => void
}

const NotificationsList: React.FC<NotificationsListProps> = ({ client, onChange }: NotificationsListProps) => {
    const dispatch = useAppDispatch()

    const deleteNotification = (index: number) => {
        if (!client) return
        const newNotifications = client?.notifications.filter((_, i) => i !== index - 1)
        onChange({ ...client, notifications: newNotifications })
        dispatch(displayMessage({ message: 'Upozornění smazáno', type: 'success' }))
    }

    const addNotification = () => {
        if (!client) return
        const newNotifications = [...(client?.notifications ?? null), getEmptyNotificationObject()]
        onChange({ ...client, notifications: newNotifications })
        dispatch(displayMessage({ message: 'Upozornění přidáno', type: 'success' }))
    }

    const editNotification = (index: number, editedNotification: NotificationDto) => {
        if (!client) return
        const newNotifications = [...(client?.notifications ?? null)]
        newNotifications[index - 1] = editedNotification
        onChange({ ...client, notifications: newNotifications })
    }

    return (
        <Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='h6' color='primary'>
                    Upozornění
                </Typography>
                <SmallPlusButton onClick={addNotification} extraSmall />
            </Stack>

            {!client.notifications.length && 'žádné upozornění'}
            {client.notifications.map((notification: NotificationDto, i: number) => (
                <Notification
                    deleteNotification={deleteNotification}
                    editNotification={editNotification}
                    notification={notification}
                    key={i}
                    id={i + 1}
                />
            ))}
        </Stack>
    )
}

export default NotificationsList
